(function () {
  // Bundable: hide ONLY the quantity selector for bundle cart lines (a bundle is a fixed unit),
  // on desktop and mobile. The mobile "Edit" button is left untouched — only the quantity
  // control it reveals gets hidden.
  // Detects a bundle by product_type "Bundle" (set by Bundable) or a _bundable_* line property.
  function isBundle(item) {
    if ((item.product_type || "").toLowerCase() === "bundle") return true;
    for (var k in (item.properties || {})) if (k.indexOf("_bundable") === 0) return true;
    return false;
  }

  function hideQtyFor(input) {
    var box = input.closest(".cart__qty") || input.parentElement;
    // !important survives a class-based Edit toggle; the observer re-hides if the theme
    // re-shows it via an inline style.
    if (box && box.style.getPropertyValue("display") !== "none") {
      box.style.setProperty("display", "none", "important");
    }
  }

  function hideBundleQty() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          if (!isBundle(item)) return;
          var targetId = "updates_" + item.variant_id;
          // .cart__qty-input is on BOTH the desktop and mobile fields
          // (the mobile field has no name="updates[]").
          document.querySelectorAll('input.cart__qty-input, input[name="updates[]"]').forEach(function (input) {
            if (input.id === targetId) hideQtyFor(input);
          });
        });
      })
      .catch(function () {});
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(hideBundleQty, 300); }
  document.addEventListener("DOMContentLoaded", schedule);
  schedule(); // run immediately too, in case DOMContentLoaded already fired
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();